export default "__VITE_ASSET__a7c2fa38__"